import store from '@/store';

export default {
   path: '/multicotizador/agro',
   name: 'agro',
   children: [
      {
         path: 'pago',
         name: 'agro/pago',
         component: () => import('@/modules/agro/views/PagoView.vue'),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.lotes.length === 0) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.poliza.id_compania === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
      {
         path: 'lote/alta',
         name: 'agro/lote/alta',
         component: () => import('@/modules/agro/views/LoteView.vue'),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
      {
         path: 'planes',
         name: 'agro/opciones',
         component: () => import('@/modules/agro/views/PlanesView.vue'),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.lotes.length === 0) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
      {
         path: 'consulta',
         name: 'agro/consulta',
         component: () => import('@/modules/agro/views/MapaView.vue'),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.lotes.length === 0) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.poliza.id_compania === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.poliza.id_forma_pago === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            next();
         },
      },
   ],
};
